import {
  SECTION_INFORMATION,
  SECTION_PRODUCT_FEATURES,
  SECTION_FEEDING_GUIDES,
  SECTION_BRANDING,
  SECTION_COMPOSITIONS,
  SECTION_PACKAGING_FEATURES,
  SECTION_OTHER_LEGAL_ELEMENTS,
  SECTION_NUTRITIONAL_LEGAL_ELEMENTS,
  SECTION_PRODUCT_MEDIA,
  SECTION_BUCKET,
  SECTION_BREEDS,
  SECTION_TEAM,
  SECTION_GMC_INFORMATION,
  SECTION_RMC_INFORMATION
} from '@modules/piu/constants/sectionsConstants';

type SectionId =
  | typeof SECTION_INFORMATION
  | typeof SECTION_PRODUCT_FEATURES
  | typeof SECTION_FEEDING_GUIDES
  | typeof SECTION_BRANDING
  | typeof SECTION_COMPOSITIONS
  | typeof SECTION_PACKAGING_FEATURES
  | typeof SECTION_OTHER_LEGAL_ELEMENTS
  | typeof SECTION_NUTRITIONAL_LEGAL_ELEMENTS
  | typeof SECTION_PRODUCT_MEDIA
  | typeof SECTION_BUCKET
  | typeof SECTION_BREEDS
  | typeof SECTION_GMC_INFORMATION
  | typeof SECTION_RMC_INFORMATION
  | typeof SECTION_TEAM
  | string;

export const mapSectionData = (
  section: SectionId,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sectionData: any
) => {
  switch (section) {
    case SECTION_INFORMATION:
      return {
        name: sectionData?.name,
        status: sectionData?.status,
        portfolio: sectionData?.portfolio,
        productCategory: sectionData?.productCategory,
        productType: sectionData?.productType,
        species: sectionData?.species,
        technology: sectionData?.technology,
        sizes: sectionData?.sizes,
        feedingPeriodFrom: sectionData?.feedingPeriodFrom,
        feedingPeriodTo: sectionData?.feedingPeriodTo,
        recommendedFors: sectionData?.recommendedFors,
        notRecommendedFors: sectionData?.notRecommendedFors,
        lifestages: sectionData?.lifestages,
        specificNeeds: sectionData?.specificNeeds,
        sterilized: sectionData?.sterilized,
        environments: sectionData?.environments,
        territory: sectionData?.territory,
        energyCategory: sectionData?.energyCategory,
        vetPrograms: sectionData?.vetPrograms,
        retailChannel: sectionData?.retailChannel,
        pillar: sectionData?.pillar,
        brand: sectionData?.brand,
        range: sectionData?.range
      };
    case SECTION_PRODUCT_FEATURES:
      return {
        preflightReports: sectionData?.preflightReports,
        commercialLabel: sectionData?.commercialLabel,
        facingTitle: sectionData?.facingTitle,
        legalTextSubHeading: sectionData?.legalTextSubHeading,
        productBenefitsIntentions: sectionData?.productBenefitsIntentions,
        formulaFeaturesIntentions: sectionData?.formulaFeaturesIntentions,
        sensitivitiesIntentions: sectionData?.sensitivitiesIntentions,
        graphicalElementsTextsIntentions: sectionData?.graphicalElementsTextsIntentions,
        productBenefits: sectionData?.productBenefits,
        formulaFeatures: sectionData?.formulaFeatures,
        sensitivities: sectionData?.sensitivities,
        graphicalElementTexts: sectionData?.graphicalElementTexts,
        legalTextHeading: sectionData?.legalTextHeading,
        feedingInstructions: sectionData?.feedingInstructions
      };
    case SECTION_PACKAGING_FEATURES:
      return {
        preflightReports: sectionData?.preflightReports,
        packagingFeatures: sectionData?.packagingFeatures
      };
    case SECTION_FEEDING_GUIDES:
      return {
        preflightReports: sectionData?.preflightReports,
        feedingGuideTexts: sectionData?.feedingGuideTexts
      };
    case SECTION_BRANDING:
      return {
        brandTexts: sectionData?.brandTexts,
        preflightReports: sectionData?.preflightReports,
        rangeTexts: sectionData?.rangeTexts
      };
    case SECTION_OTHER_LEGAL_ELEMENTS:
      return {
        preflightReports: sectionData?.preflightReports,
        otherLegalElements: sectionData?.otherLegalElements
      };
    case SECTION_PRODUCT_MEDIA:
      return {
        productMedia: sectionData?.productMedia
      };
    case SECTION_BUCKET:
      return {
        status: sectionData?.bucket?.status,
        id: sectionData?.bucket?.id,
        files: sectionData?.files
      };
    case SECTION_TEAM:
      return {
        brandPortfolioManagers: sectionData?.brandPortfolioManagers
      };
    case SECTION_BREEDS:
      return {
        breeds: sectionData?.breeds
      };
    case SECTION_GMC_INFORMATION:
      return {
        name: sectionData?.name,
        launchYear: sectionData?.launchYear,
        idppm: sectionData?.idppm,
        skus: sectionData?.skus,
        reasonOfLaunch: sectionData?.reasonOfLaunch,
        subVersionLabel: sectionData?.subVersionLabel,
        status: sectionData?.status
      };
    case SECTION_NUTRITIONAL_LEGAL_ELEMENTS:
      return {
        preflightReports: sectionData?.preflightReports,
        legalTextHeading: sectionData?.legalTextHeading,
        parnuts: sectionData?.parnuts,
        feedingInstructions: sectionData?.feedingInstructions,
        productDestination: sectionData?.productDestination,
        dvpStatement: sectionData?.dvpStatement,
        aafcoNutritionalAdequacyStatement: sectionData?.aafcoNutritionalAdequacyStatement
      };
    case SECTION_RMC_INFORMATION:
      return {
        deployedCountries: sectionData?.deployedCountries,
        region: sectionData?.region,
        regulatoryZone: sectionData?.regulatoryZone,
        status: sectionData?.status
      };
    case SECTION_COMPOSITIONS:
      return {
        collection: sectionData?.compositions
      };
    default:
      throw new Error(`Section ${section} not found`);
  }
};
